import {
    ADDUPDATESMSPROVIDER_SUCCESS,
    ADDUPDATESMSPROVIDER_FAILED,
    RESET_ADDUPDATESMSPROVIDER,
    LOADING_ADDUPDATESMSPROVIDER,
    NETWORK_ERROR_ADDUPDATESMSPROVIDER,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminSMSProvider = () => {
    return { type: RESET_ADDUPDATESMSPROVIDER };
};

const AdminAddUpdateSMSProvider = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDUPDATESMSPROVIDER });
    await adminServices
        .post("addUpdateSmsProvider", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminAddUpdateSMSProvidersuccess(res.data));
                    break;
                default:
                    dispatch(AdminAddUpdateSMSProviderFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDUPDATESMSPROVIDER,
                payload: err
            });
        });
};


function AdminAddUpdateSMSProvidersuccess(data) {
    return {
        type: ADDUPDATESMSPROVIDER_SUCCESS,
        payload: data
    };
}
function AdminAddUpdateSMSProviderFailed(data) {
    return {
        type: ADDUPDATESMSPROVIDER_FAILED,
        payload: data
    };
}

export { AdminAddUpdateSMSProvider, resetAdminSMSProvider }